import { ProtectedRouteConfig } from '@/shared/types/routes'
import { UserTypes } from '@/shared/types/auth'

/**
 * Configuration for the current paths we have on the app.
 * It is using base on permissions.
 *
 * IMPORTANT
 * { resource: 'sudo', action: '', scope: '' } needs to be added to
 * for all pages for Super Admin
 *
 */
export const PROTECTED_ROUTES: Record<string, ProtectedRouteConfig> = {
    '/user/dashboard': {
        path: '/user/dashboard',
        requireAuth: true
    },
    '/user/settings': {
        path: '/user/settings',
        requireAuth: true
    },
    '/user/parent': {
        // Deprecated page, will be removed later
        path: '/user/parent',
        requireAuth: true,
        allowedTypes: [UserTypes.IS_PARENT, UserTypes.IS_GLOBAL_ADMIN]
    },
    '/user/coparent': {
        path: '/user/coparent',
        requireAuth: true,
        allowedTypes: [UserTypes.IS_PARENT, UserTypes.IS_GLOBAL_ADMIN]
    },
    '/user/parent/alternative-contact': {
        path: '/user/parent/alternative-contact',
        requireAuth: true,
        allowedTypes: [UserTypes.IS_PARENT, UserTypes.IS_GLOBAL_ADMIN]
    },
    '/user/parent/children-list': {
        path: '/user/parent/children-list',
        // Any signed-in user may add children — the backend transparently
        // creates a Parent record on first child-add (children.service.create),
        // so a teacher who now has a child can register them here in one step,
        // matching the mobile app. No pre-flight "request parent role" needed.
        requireAuth: true
    },
    '/user/parent/duplicates': {
        // Reached from the "suspected duplicate account" notification. Any
        // signed-in user may open it: the page resolves their own parent record
        // and shows an empty state when there is none.
        path: '/user/parent/duplicates',
        requireAuth: true
    },
    '/user/parent/children-list/[id]': {
        path: '/user/parent/children-list/[id]',
        requireAuth: true
    },
    /**
     * Teacher's Route
     */
    '/user/teacher': {
        // Deprecated page, will be removed later
        path: '/user/teacher',
        requireAuth: true,
        allowedTypes: [
            UserTypes.IS_TEACHER,
            UserTypes.IS_ADMIN_TEACHER,
            UserTypes.IS_GLOBAL_ADMIN
        ]
    },
    '/user/teacher/check-in-out': {
        path: '/user/teacher/check-in-out',
        requireAuth: true,
        allowedTypes: [
            UserTypes.IS_TEACHER,
            UserTypes.IS_ADMIN_TEACHER,
            UserTypes.IS_GLOBAL_ADMIN
        ]
    },
    '/user/teacher/queue': {
        path: '/user/teacher/queue',
        requireAuth: true,
        allowedTypes: [
            UserTypes.IS_TEACHER,
            UserTypes.IS_ADMIN_TEACHER,
            UserTypes.IS_GLOBAL_ADMIN
        ]
    },
    '/user/teacher/teacher-report': {
        path: '/user/teacher/teacher-report',
        requireAuth: true,
        allowedTypes: [
            UserTypes.IS_TEACHER,
            UserTypes.IS_ADMIN_TEACHER,
            UserTypes.IS_GLOBAL_ADMIN
        ]
    },
    '/user/teacher/parents': {
        path: '/user/teacher/parents',
        requireAuth: true,
        allowedTypes: [UserTypes.IS_ADMIN_TEACHER, UserTypes.IS_GLOBAL_ADMIN]
    },
    '/user/teacher/teachers': {
        path: '/user/teacher/teachers',
        requireAuth: true,
        allowedTypes: [UserTypes.IS_ADMIN_TEACHER, UserTypes.IS_GLOBAL_ADMIN]
    },
    '/user/teacher/duplicate-registration': {
        // Reviewing a pair merges two parents and deletes one of them, so this
        // stays with admin teachers even though the backend endpoints are only
        // JwtAuthGuard-protected.
        path: '/user/teacher/duplicate-registration',
        requireAuth: true,
        allowedTypes: [UserTypes.IS_ADMIN_TEACHER, UserTypes.IS_GLOBAL_ADMIN]
    }
}
